import React, { useContext, useState, useEffect } from 'react';
import { RicosContext, ModalContext } from 'ricos-context';
import { DropdownButton } from 'wix-rich-content-toolbars-ui';
import PollSettingsModal from '../components/modals/SettingsModal.js';
import { pollModals } from '../consts.js';
import { layoutData } from './PollButtonsData.js';
import { TABS } from '../components/settings/constants.js';
import { LayoutGridIcon } from '../assets/icons/LayoutGridIcon.js';
import '../types.js';
import '../components/settings/SettingsModal.js';
import 'classnames';
import 'prop-types';
import 'react-modal';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import '../dataHooks.js';
import '../viewer/poll-viewer.js';
import 'wix-rich-content-editor-common/libs/EditorEventsContext';
import '../components/rce-helpers-context/index.js';
import '../viewer/poll-component.js';
import 'react-flip-move';
import 'react-measure';
import '../style-inject.es-746bb8ed.js';
import '../components/poll-option/index.js';
import '../defaults-0542c304.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../components/poll-option/PollGridOption.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../RemoveOption-0fb59667.js';
import '../assets/icons/RemoveIcon.js';
import '../components/poll-option/PollOptionBase.js';
import '../components/poll-option/types.js';
import '../components/poll-context/types.js';
import '../assets/icons/NonEditableIcon.js';
import '../assets/icons/CheckIcon.js';
import '../components/image-upload/ImageUpload.js';
import '../components/image-upload/types.js';
import '../assets/icons/LoaderIcon.js';
import '../assets/icons/ReplaceIcon.js';
import '../components/text-field/TextField.js';
import 'lodash';
import '../components/poll-option/PollListOption.js';
import '../components/poll-option/webview/PollListOptionWebview.js';
import '../option-webview-c29b68a5.js';
import '../components/poll-option/webview/PollGridOptionWebview.js';
import '../components/poll-header/PollHeader.js';
import '../components/poll-context/PollContext.js';
import '../components/voted-users/VotedUsers.js';
import '../components/voted-users/types.js';
import '../VotedUsersModal-b3691022.js';
import 'react-infinite-scroller';
import '../components/voted-users/VoterAvatar.js';
import '../components/voted-users/FallbackAvatar.js';
import '../assets/icons/AddIcon.js';
import '../components/settings/edit-poll-section/EditPollSection.js';
import '../components/settings/layout-settings-section/LayoutSettingsSection.js';
import 'wix-rich-content-plugin-commons';
import '../assets/icons/LayoutListIcon.js';
import '../components/settings/design-settings-section/DesignSettingsSection.js';
import '../assets/icons/ColorIcon.js';
import '../assets/icons/GradientIcon.js';
import '../assets/icons/ImageIcon.js';
import '../components/settings/poll-settings-section/PollSettingsSection.js';
import 'ricos-schema';
import '../assets/icons/LayoutGridIconNew.js';
import '../assets/icons/LayoutListIconNew.js';

const PollLayoutButton = ({ toolbarItem, id, dataHook, config }) => {
  const { t, isMobile } = useContext(RicosContext) || {};
  const modalService = useContext(ModalContext) || {};
  const node = toolbarItem.attributes.selectedNode;
  const getSelectedLayout = () => {
    var _a, _b, _c;
    return ((_c = (_b = (_a = node == null ? void 0 : node.attrs) == null ? void 0 : _a.layout) == null ? void 0 : _b.poll) == null ? void 0 : _c.type) || "GRID";
  };
  const [referenceElement, setReferenceElement] = useState(null);
  const closeModal = () => modalService.closeModal(id);
  const selectedLayout = layoutData.find(({ commandKey }) => commandKey === getSelectedLayout());
  const Icon = (selectedLayout == null ? void 0 : selectedLayout.icon) || LayoutGridIcon;
  const label = (selectedLayout == null ? void 0 : selectedLayout.text) || "Poll_PollSettings_Tab_Layout_Section_Answers_Layout_Grid";
  const onLayoutClick = (layout) => {
    var _a;
    (_a = toolbarItem.commands) == null ? void 0 : _a.click({ value: layout });
    closeModal();
  };
  const onCustomizeButtonClick = () => {
    modalService == null ? void 0 : modalService.openModal(pollModals.settings, {
      componentProps: {
        nodeId: toolbarItem.attributes.selectedNode.attrs.id,
        activeTab: TABS.LAYOUT,
        settings: { showVoteRoleSetting: config == null ? void 0 : config.showVoteRoleSetting }
      },
      positioning: { placement: "right" },
      layout: isMobile ? "fullscreen" : "drawer"
    });
    closeModal();
  };
  const onClick = () => {
    modalService.isModalOpen(id) ? closeModal() : modalService == null ? void 0 : modalService.openModal(id, {
      componentProps: {
        getSelectedLayout,
        onClick: onLayoutClick,
        onCustomizeButtonClick,
        closeModal
      },
      layout: isMobile ? "drawer" : "toolbar",
      positioning: { referenceElement, placement: "bottom" }
    });
  };
  useEffect(() => {
    !modalService.getModal(pollModals.layout) && modalService.register({
      Component: PollSettingsModal,
      id: pollModals.layout
    });
  }, []);
  return /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      dataHook,
      active: modalService.isModalOpen(id),
      onClick,
      setRef: setReferenceElement,
      Icon,
      label: t(label),
      tooltip: t("Poll_PollSettings_Tab_Layout_TabName")
    }
  );
};

export { PollLayoutButton };
//# sourceMappingURL=PollLayoutButton.js.map
